// extracted by mini-css-extract-plugin
export default {"root":"styles_root__W550G","label":"styles_label__Z+sQM","active":"styles_active__txCFE","selected":"styles_selected__mMwVB"};